import apiBase from "../../api/axios";

const BASE_URL = "v1/talentos-plantel/configuracion-aplicacion";

// Obtiene (o crea con defaults) la config de aplicación del plantel.
export const getConfiguracionAplicacionPlantelService = async (plantelId) => {
  const response = await apiBase.get(`${BASE_URL}/por-plantel/`, {
    params: { plantel: plantelId },
  });
  return response.data;
};

// Actualiza la frase y las etiquetas Sí/No.
export const updateConfiguracionAplicacionPlantelService = async (
  id,
  { frase, etiqueta_si, etiqueta_no },
) => {
  const response = await apiBase.patch(`${BASE_URL}/${id}/`, {
    frase,
    etiqueta_si,
    etiqueta_no,
  });
  return response.data;
};
